export const MODAL_TYPE_PC = {
  CONFIRM_MODAL: 'CONFIRM_MODAL',
  CONFIRM_CANCEL_MODAL: 'CONFIRM_CANCEL_MODAL',
  INPUT_MODAL: 'INPUT_MODAL',
  GIFT_HEART_MODAL: 'GIFT_HEART_MODAL',
  SEND_ITEM_MODAL: 'SEND_ITEM_MODAL',
  GIFTABLE_ITEM_MODAL: 'GIFTABLE_ITEM_MODAL',

  SEND_MESSAGE_MODAL: 'SEND_MESSAGE_MODAL',
  SEND_MESSAGE_WITHOUT_TARGET_MODAL: 'SEND_MESSAGE_WITHOUT_TARGET_MODAL',
  POST_DETAIL_MODAL: 'POST_DETAIL_MODAL',
  RECEIVE_MESSAGE_SETTING_MODAL: 'RECEIVE_MESSAGE_SETTING_MODAL',

  BROADCAST_SHARE_MODAL: 'BROADCAST_SHARE_MODAL',
  BROADCAST_SPON_MODAL: 'BROADCAST_SPON_MODAL',

  STORE_MODAL: 'STORE_MODAL',
  PURCHASE_MODAL: 'PURCHASE_MODAL',
  BANK_MODAL: 'BANK_MODAL',
  BANK_RESULT_MODAL: 'BANK_RESULT_MODAL',
  CASH_BILL_MODAL: 'CASH_BILL_MODAL',
  CASH_BILL_RECEIPT_DETAIL_MODAL: 'CASH_BILL_RECEIPT_DETAIL_MODAL',
  RESERVATIONCALENDER_MODAL: 'RESERVATIONCALENDER_MODAL',
  ARS_AUTH_MODAL: 'ARS_AUTH_MODAL',

  ITEM_DETAIL_MODAL: 'ITEM_DETAIL_MODAL',
  NICK_DECO_MODAL: 'NICK_DECO_MODAL',
  INTRO_EFFECT_MODAL: 'INTRO_EFFECT_MODAL',

  SEND_PUSH_MODAL: 'SEND_PUSH_MODAL',
  FAN_GRADE_OPTION_MODAL: 'FAN_GRADE_OPTION_MODAL',

  LIST_BACKGROUND_PREVIEW_MODAL: 'LIST_BACKGROUND_PREVIEW_MODAL',

  AUTH_MODAL: 'AUTH_MODAL',
  BANNER_MODAL: 'BANNER_MODAL',
  PASSWORD_ENTRY_MODAL: 'PASSWORD_ENTRY_MODAL',
  VOTE_MODAL: 'VOTE_MODAL',

  SIGNATURE_EMOTICON_GUIDE_MODAL: 'SIGNATURE_EMOTICON_GUIDE_MODAL',
  SIGNATURE_EMOTICON_REGISTRATION_MODAL: 'SIGNATURE_EMOTICON_REGISTRATION_MODAL',

  PROFILE_IMAGE_EDIT_MODAL: 'PROFILE_IMAGE_EDIT_MODAL',

  CHANNEL_EDIT_MODAL: 'CHANNEL_EDIT_MODAL',
  CHANNEL_IMAGE_EDIT_MODAL: 'CHANNEL_IMAGE_EDIT_MODAL',
  REPORT_MODAL: 'REPORT_MODAL',
  RT_OPINION_MODAL: 'RT_OPINION_MODAL',
  LIVE_PICK_MODAL: 'LIVE_PICK_MODAL',
  BROADCAST_START_MODAL: 'BROADCAST_START_MODAL',
  BROADCAST_SETTING_GUIDE_MODAL: 'BROADCAST_SETTING_GUIDE_MODAL',
  TRANSMISSION_MODAL: 'TRANSMISSION_MODAL',
  HELPER_WIDGET_GUIDE_MODAL: 'HELPER_WIDGET_GUIDE_MODAL',

  NOTICE_WRITE_MODAL: 'NOTICE_WRITE_MODAL',
  NOTICE_INFO_MODAL: 'NOTICE_INFO_MODAL',

  FAN_RANK_WRITE_MODAL: 'FAN_RANK_WRITE_MODAL',

  BLOCK_ADD_MODAL_CONTAINER: 'BLOCK_ADD_MODAL_CONTAINER',

  IMAGE_LIST_MODAL: 'IMAGE_LIST_MODAL',
  MARKETING_CONSENT_MODAL: 'MARKETING_CONSENT_MODAL',
  ADD_COUPON_MODAL: 'ADD_COUPON_MODAL',
  IDENTITY_VERIFICATION_MODAL: 'IDENTITY_VERIFICATION_MODAL',
  AUTH_ACCOUNT_CHECK_MODAL: 'AUTH_ACCOUNT_CHECK_MODAL',
  PLAY_YOUTH_POLICY_MODAL: 'PLAY_YOUTH_POLICY_MODAL',
  BROADCAST_RULE_MODAL: 'BROADCAST_RULE_MODAL',
  PRIVACY_COLLECT_POLICY_MODAL: 'PRIVACY_COLLECT_POLICY_MODAL',
  PRIVACY_CONSIGN_POLICY_MODAL: 'PRIVACY_CONSIGN_POLICY_MODAL',
  IMAGE_CROP_MODAL: 'IMAGE_CROP_MODAL',
  NOTIFICATION_MODAL: 'NOTIFICATION_MODAL',

  NOTIFICATION_PER_BROWSER_RECEIVE_CONFIG_MODAL: 'NOTIFICATION_PER_BROWSER_RECEIVE_CONFIG_MODAL',

  ADULT_WARNING_MODAL: 'ADULT_WARNING_MODAL',

  NOTIFICATION_TALK_SETTING_MODAL: 'NOTIFICATION_TALK_SETTING_MODAL',
  RECAPTCHA_MODAL: 'RECAPTCHA_MODAL',
  GLOBAL_SERVICE_PROFILE_EDIT_MODAL: 'GLOBAL_SERVICE_PROFILE_EDIT_MODAL',
  GLOBAL_SERVICE_PROFILE_PREVIEW_MODAL: 'GLOBAL_SERVICE_PROFILE_PREVIEW_MODAL',
  GLOBAL_SERVICE_BROADCAST_AGREE_MODAL: 'GLOBAL_SERVICE_BROADCAST_AGREE_MODAL',
} as const;

export const MODAL_TYPE_MOBILE = {
  CONFIRM_MODAL: 'CONFIRM_MODAL',
  CONFIRM_CANCEL_MODAL: 'CONFIRM_CANCEL_MODAL',
  SEND_MESSAGE_MODAL: 'SEND_MESSAGE_MODAL',
  RESERVATIONCALENDER_MODAL: 'RESERVATIONCALENDER_MODAL',
  AUTH_MODAL: 'AUTH_MODAL', // login modal
  BANNER_MODAL: 'BANNER_MODAL',
  PASSWORD_ENTRY_MODAL: 'PASSWORD_ENTRY_MODAL',
  PROFILE_IMAGE_EDIT_MODAL: 'PROFILE_IMAGE_EDIT_MODAL',
  IMAGE_LIST_MODAL: 'IMAGE_LIST_MODAL',
  MARKETING_CONSENT_MODAL: 'MARKETING_CONSENT_MODAL',
  PLAY_YOUTH_POLICY_MODAL: 'PLAY_YOUTH_POLICY_MODAL',
  IMAGE_CROP_MODAL: 'IMAGE_CROP_MODAL',
  ADULT_WARNING_MODAL: 'ADULT_WARNING_MODAL',
  RECAPTCHA_MODAL: 'RECAPTCHA_MODAL',
  BANNER_IMAGE_EDIT_MODAL: 'BANNER_IMAGE_EDIT_MODAL',
  IDENTITY_VERIFICATION_MODAL: 'IDENTITY_VERIFICATION_MODAL',
} as const;
